import { Toggle } from "~/components/Toggle";
import { cn } from "~/lib/utils";

export function BooleanValueInput(props: {
    value: boolean;
    onChange: (updatedValue: boolean) => void;
}) {
    const { value, onChange } = props;

    return (
        <div className="flex items-center gap-4 ml-2">
            <span
                className={cn({
                    "text-muted-foreground/50": value,
                    "text-foreground": !value,
                })}
            >
                {"False"}
            </span>

            <Toggle
                checked={value}
                color="blue"
                size="lg"
                onChange={(updatedValue: boolean) => {
                    onChange(updatedValue);
                }}
            />

            <span
                className={cn({
                    "text-muted-foreground/50": !value,
                    "text-foreground": value,
                })}
            >
                {"True"}
            </span>
        </div>
    );
}
